import { getAnalyticsItemType } from '@mb/lib';
import { getAnalyticsItemCategoriesByTaxonomy } from './getAnalyticsItemCategoriesByTaxonomy';
import { ProductSearchMaterial } from '../../../../pages/ProductSearch/types';

export const handleMiniPdpVariantClickDataLayer = (
  product: ProductSearchMaterial,
) => {
  dataLayer.push({
    event: 'minipdp_item_variant_selected',
    event_location: 'Quick-View',
    ecommerce: {
      currency: 'USD',
      value: 0,
      items: [
        {
          item_id: product.entityId,
          item_name: product?.associatedItem,
          item_brand: product?.manufacturer,
          item_type: getAnalyticsItemType(product),
          ...getAnalyticsItemCategoriesByTaxonomy(product?.taxonomy),
          index: 1,
          price: 0,
          quantity: 1,
          item_list_id: 'quick_view',
          item_list_name: 'Quick View',
          item_variant: product.name,
        },
      ],
    },
  });
};
